import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tuisong",
  "use": "icon-tuisong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tuisong\"><path fill=\"#EE0B79\" d=\"M115.2 435.2C83.2 448 64 480 64 512s12.8 64 44.8 83.2l102.4 70.4c12.8 12.8 32 6.4 44.8-6.4s0-38.4-12.8-44.8L140.8 544C128 537.6 128 524.8 128 518.4c0-6.4 0-19.2 19.2-25.6l665.6-332.8L320 755.2v172.8c0 19.2 12.8 32 32 32s32-12.8 32-32v-147.2L870.4 192l-147.2 672c0 12.8-6.4 19.2-19.2 25.6-12.8 6.4-19.2 6.4-32 0l-108.8-70.4c-12.8-12.8-32-6.4-44.8 6.4-12.8 6.4-6.4 25.6 6.4 32l108.8 70.4c19.2 12.8 32 19.2 51.2 19.2 12.8 0 25.6 0 38.4-6.4 32-12.8 51.2-38.4 57.6-70.4l192-864L115.2 435.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/tuisong.svg
// module id = KHM2
// module chunks = 78